module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"projects":"Projects","contact":"Contact","experience":"Experience","tracking":"Disable GA tracking"},"fi":{"projects":"Projektit","contact":"Yhteystiedot","experience":"Kokemus","tracking":"Kytke GA pois päältä"}}')
  delete Component.options._Ctor
}
